import { ObjectDirective } from "vue"

const directive: ObjectDirective = {
    inserted(el, binding, vnode) {
        el.clickOutsideEvent = function (event) {
            if (el === event.target) {
                vnode.context[binding.expression](event);
            }
        };
        document.body.addEventListener('click', el.clickOutsideEvent);
    }
};

export default directive;